var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"font-icon",class:[_vm.isElIcon ? _vm.icon : 'iconfont ' + _vm.icon]})
}
var staticRenderFns = []

export { render, staticRenderFns }